const colors = {
  //background Blue
  blue: "#e0f0ff",
  blueText: "#00527C",
  white: "#fff",
  green: "#539C7A",
  greenGrey: "#0C5132",
  red: "#EF7666",
  yellow: "#FFCD4C",
  grey: "#616161",
  greyForBorderLine: "#e4e5e7",
  // blue for text
  dark: "#202223",
  redDark: "#8e0B21",
};

const paletteColors = {
  light: {
    ...colors,
    mode: "light",
    text: { primary: colors.white },
    background: { paper: "#fff", blue: colors.blue },
  },
};

export default paletteColors;
